// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "disturbance-frontend/js/" + chunkId + "." + "bcd091d66e96a3f7eadf" + ".bundle.js";
};